// Pure ship-placement helpers shared by the battleship slice (authoritative
// placement) and the Battleship component (hover preview).

export const BOARD_SIZE = 10;

/** Cells a ship of `size` would occupy from (x, y) in `dir`, or null if off-board */
export function getShipCells(x, y, size, dir) {
  const cells = [];
  for (let i = 0; i < size; i++) {
    const cx = dir === 'horizontal' ? x + i : x;
    const cy = dir === 'horizontal' ? y : y + i;
    if (cx >= BOARD_SIZE || cy >= BOARD_SIZE) return null;
    cells.push({ x: cx, y: cy });
  }
  return cells;
}

/** Ships may not touch, even diagonally */
export function canPlaceShip(board, cells) {
  if (!cells) return false;
  for (const { x, y } of cells) {
    for (let dy = -1; dy <= 1; dy++) {
      for (let dx = -1; dx <= 1; dx++) {
        const nx = x + dx, ny = y + dy;
        if (nx >= 0 && nx < BOARD_SIZE && ny >= 0 && ny < BOARD_SIZE) {
          if (board[ny][nx] === 1 && !cells.some((c) => c.x === nx && c.y === ny)) {
            return false;
          }
        }
      }
    }
  }
  return true;
}

export function emptyPlacementBoard() {
  return Array.from({ length: BOARD_SIZE }, () => Array(BOARD_SIZE).fill(0));
}
